import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { useNavigate } from "react-router-dom";
//API
import ItemService from "../../../../../services/inventory_appCommonService";
//Components
import { InputField } from "../../../../../Components/formElements/InputField";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";
// import toast from "react-hot-toast";
import Layout from "../../../../../Layout/Layout";
import { isValidNumber, } from "../../../../../common/Validations";
import { useSelector } from "react-redux";
// import InventoryConstants from "../../../../../common/InventoryConstants";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  NUMBER_ALLOWED: "Please enter a valid number."
};

const OrderDetails = () => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const orderWhnr = useSelector((state) => state?.inventory?.whOrder?.whOrderNr)

  const [isCardVisible, setCardVisible] = useState(true);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, /*setErrorFields*/] = useState([]);

  const [validation, setValidation] = useState({
    Quantity: "",
    // confirmedQty: "",

  });
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const onInputChange = ({ target: { name, value } }) => {

    let error = "";

    if (name === "Quantity" && !isValidNumber(value)) {
      error = message.NUMBER_ALLOWED;
    }
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };
  const [formInputs, setFormInputs] = useState({
    warehouseNr: "",
    warehouseStatus: "",
    orderDate: "",
    activityArea: "",
    woCreatnRule: "",
    resource: "",
    queue: "",
    wave: "",
    createdBy: "",
    processor: "",
    confirmedBy: "",

    warehouseTask: "",
    wtStatus: "",
    product: "",
    batchNr: "",
    serialNoReqm: "",
    sourceBin: "",
    destinationBin: "",
    srceTgtQty: "",
    actDestQty: "",
    actualQtyVum: "",
    destDiffQty: "",
    diffQtyVum: "",
    remQtySource: "",
    exceptionCode: "",
    ptwyPiPlan: "",
    ptwyPiDone: "",
    lowStockQty: "",
    procCategory: "",
    sourceHu: "",
    destinationHu: "",
    actualPos: "",
    destResource: "",
    destinationTu: "",
    grDate: "",
    expiration: "",
    slsOrderProj: "",
    docCatDeter: "",
    owner: "",
    disposalParty: ""
  });

  const loadFirstLevelData = async (page) => {
    if (orderWhnr) {
      let obj = {
        documentNumber: orderWhnr,
      };
      await ItemService.getProductionOrderDatails(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
    }
  };

  useEffect(() => {
    loadFirstLevelData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // const [disabled, setDisabled] = useState(false);


  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  //bank end
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Order Details</h2>
            <p className="subText">
              {/* Register as a new Vehicle or Sub-Contractor with our Company */}
            </p>
            <hr />
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">WO</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Warehouse Order </span>
                      <span className="subHeaderTitle">WareHouse Order Entry</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Warehouse Nr"
                          name="warehousrNr"
                          placeholder=""
                          value={formInputs?.warehousrNr || ""}
                          onChange={onInputChange}
                          error={validation.warehousrNr}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Warehouse Status"
                          name="warehouseStatus"
                          placeholder=""
                          value={formInputs?.warehouseStatus || ""}
                          onChange={onInputChange}
                          error={validation?.warehouseStatus}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="Date"
                          name="orderDate"
                          id="orderDate"
                          value={formInputs?.orderDate}
                          onChange={onInputChange}
                          disabled={true}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Activity Area"
                          name="activityArea"
                          placeholder=""
                          value={formInputs?.activityArea || ""}
                          onChange={onInputChange}
                          error={validation.activityArea}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="WO Creatn Rule"
                          name="woCreatnRule"
                          placeholder=""
                          value={formInputs?.woCreatnRule || ""}
                          onChange={onInputChange}
                          error={validation.woCreatnRule}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Resource"
                          name="resource"
                          placeholder=""
                          value={formInputs?.resource || ""}
                          onChange={onInputChange}
                          error={validation.resource}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Queue"
                          name="queue"
                          placeholder=""
                          value={formInputs?.queue || ""}
                          onChange={onInputChange}
                          disabled={true}
                          error={validation.queue}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Wave"
                          name="wave"
                          placeholder=""
                          value={formInputs?.wave || ""}
                          onChange={onInputChange}
                          error={validation.wave}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created By"
                          name="createdBy"
                          placeholder=""
                          value={formInputs?.createdBy || ""}
                          onChange={onInputChange}
                          error={validation.createdBy}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Processor"
                          name="processor"
                          placeholder=""
                          value={formInputs?.processor || ""}
                          onChange={onInputChange}
                          error={validation.processor}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Confirmed By"
                          name="confirmedBy"
                          placeholder=""
                          value={formInputs?.confirmedBy || ""}
                          onChange={onInputChange}
                          error={validation.confirmedBy}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PW</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Product WT </span>
                      <span className="subHeaderTitle">Product Warehouse Task</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Warehouse Task"
                          name="warehouseTask"
                          placeholder=""
                          value={formInputs.warehouseTask || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.warehouseTask}
                          disabled={true}
                        />

                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Wt Status"
                          name="wtStatus"
                          placeholder=""
                          value={formInputs?.wtStatus || ""}
                          onChange={onInputChange}
                          error={validation.wtStatus}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product"
                          name="product"
                          placeholder=""
                          value={formInputs?.product || ""}
                          onChange={onInputChange}
                          error={validation.product}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Batch"
                          name="batchNr"
                          placeholder=""
                          value={formInputs?.batchNr || ""}
                          onChange={onInputChange}
                          error={validation.batchNr}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Serial No. Reqm"
                          name="serialNoReqm"
                          placeholder=""
                          value={formInputs?.serialNoReqm || ""}
                          onChange={onInputChange}
                          error={validation.serialNoReqm}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Source Bin"
                          name="sourceBin"
                          placeholder=""
                          value={formInputs?.sourceBin || ""}
                          onChange={onInputChange}
                          error={validation.sourceBin}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Destination Bin"
                          name="destinationBin"
                          placeholder=""
                          value={formInputs?.destinationBin || ""}
                          onChange={onInputChange}
                          disabled={true}
                          error={validation.destinationBin}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Srce Tgt Qty"
                          name="srceTgtQty"
                          placeholder=""
                          value={formInputs?.srceTgtQty || ""}
                          onChange={onInputChange}
                          error={validation.srceTgtQty}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Act. Dest. Qty"
                          name="actDestQty"
                          placeholder=""
                          value={formInputs?.actDestQty || ""}
                          onChange={onInputChange}
                          error={validation.actDestQty}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Actual Qty VUM"
                          name="actualQtyVum"
                          placeholder=""
                          value={formInputs?.actualQtyVum || ""}
                          onChange={onInputChange}
                          error={validation.actualQtyVum}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dest. Diff. Qty"
                          name="destDiffQty"
                          placeholder=""
                          value={formInputs?.destDiffQty || ""}
                          onChange={onInputChange}
                          error={validation.destDiffQty}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Diff. Qty VUM"
                          name="diffQtyVum"
                          placeholder=""
                          value={formInputs?.diffQtyVum || ""}
                          onChange={onInputChange}
                          error={validation.diffQtyVum}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Rem. Qty Source"
                          name="remQtySource"
                          placeholder=""
                          value={formInputs?.remQtySource || ""}
                          onChange={onInputChange}
                          error={validation.remQtySource}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Exception Code"
                          name="exceptionCode"
                          placeholder=""
                          value={formInputs?.exceptionCode || ""}
                          onChange={onInputChange}
                          error={validation.exceptionCode}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Ptwy PI Plan"
                          name="ptwyPiPlan"
                          placeholder=""
                          value={formInputs?.ptwyPiPlan || ""}
                          onChange={onInputChange}
                          error={validation.ptwyPiPlan}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Ptwy PI Done"
                          name="ptwyPiDone"
                          placeholder=""
                          value={formInputs?.ptwyPiDone || ""}
                          onChange={onInputChange}
                          disabled={true}
                          error={validation.ptwyPiDone}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Low Stock Qty"
                          name="lowStockQty"
                          placeholder=""
                          value={formInputs?.lowStockQty || ""}
                          onChange={onInputChange}
                          error={validation.lowStockQty}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Low Stock Qty"
                          name="procCategory"
                          placeholder=""
                          value={formInputs?.procCategory || ""}
                          onChange={onInputChange}
                          error={validation.procCategory}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Source Hu"
                          name="sourceHu"
                          placeholder=""
                          value={formInputs?.sourceHu || ""}
                          onChange={onInputChange}
                          error={validation.sourceHu}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Destination Hu"
                          name="destinationHu"
                          placeholder=""
                          value={formInputs?.destinationHu || ""}
                          onChange={onInputChange}
                          error={validation.destinationHu}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Actual Pos"
                          name="actualPos"
                          placeholder=""
                          value={formInputs?.actualPos || ""}
                          onChange={onInputChange}
                          error={validation.actualPos}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dest Resource"
                          name="destResource"
                          placeholder=""
                          value={formInputs?.destResource || ""}
                          onChange={onInputChange}
                          error={validation.destResource}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Destination Tu"
                          name="destinationTu"
                          placeholder=""
                          value={formInputs?.destinationTu || ""}
                          onChange={onInputChange}
                          error={validation.destinationTu}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="GR Date"
                          name="grDate"
                          id="grDate"
                          value={formInputs?.grDate}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Expiration"
                          name="expiration"
                          placeholder=""
                          value={formInputs?.expiration || ""}
                          onChange={onInputChange}
                          error={validation.expiration}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sls Order/Proj"
                          name="slsOrderProj"
                          placeholder=""
                          value={formInputs?.slsOrderProj || ""}
                          onChange={onInputChange}
                          error={validation.slsOrderProj}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Doc Cat, Deter"
                          name="docCatDeter"
                          placeholder=""
                          value={formInputs?.docCatDeter || ""}
                          onChange={onInputChange}
                          error={validation.docCatDeter}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Owner"
                          name="owner"
                          placeholder=""
                          value={formInputs?.owner || ""}
                          onChange={onInputChange}
                          error={validation.owner}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Disposal Party"
                          name="disposalParty"
                          placeholder=""
                          value={formInputs?.disposalParty || ""}
                          onChange={onInputChange}
                          error={validation.disposalParty}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* <Row className="mb-4">
        <Col
          xs={12}
          md={{ span: 2, offset: 10 }}
          lg={{ span: 2, offset: 10 }}
          className="text-left"
        >
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>
      </Row> */}

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};

export default OrderDetails;
